<app-tdo-progress-spinner *ngIf="isLoading" data-cy="processor-device-loading-spinner"></app-tdo-progress-spinner>
<div *ngIf="!isLoading" class="section" style="flex: 1; display: flex; flex-direction: column;" data-cy="processor-device-container">
  <div class="section-header" style="flex-basis: fit-content;" data-cy="processor-device-header">
    <div class="section-header-title" data-cy="processor-device-title">Payment Processor Device Workstation</div>
  </div>

  <div class="section-content" style="display: flex; flex-direction: column; flex: 1;" data-cy="processor-device-content">
    <div style="height: 290px; overflow: auto;" data-cy="processor-device-form">
      <mat-form-field style="width:100%" data-cy="processor-device-workstation-field">
        <mat-label data-cy="processor-device-workstation-label">Workstation</mat-label>
        <mat-select [(value)]="this.processorDevice.WorkStationId" [disabled]="this.paymentDeviceID !== ''" data-cy="processor-device-workstation-select">
          <mat-option *ngFor="let ws of workStations" [value]="ws.WorkStationId" data-cy="processor-device-workstation-option">
            {{ws.WorkStationName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="processor-device-description-field">
        <mat-label data-cy="processor-device-description-label">Device Workstation Description</mat-label>
        <input matInput [(ngModel)]="this.processorDevice.Description" data-cy="processor-device-description-input">
      </mat-form-field>

      <mat-checkbox [(ngModel)]="processorDevice.isWSdefault" data-cy="processor-device-default-checkbox">Is Default</mat-checkbox>
    </div>

  </div>

  <!--  FOOTER-->
  <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="processor-device-footer">
    <div style="flex: 1; margin-right: 6px;" data-cy="processor-device-footer-spacer"></div>
    <button (click)="cancel()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="processor-device-cancel-button">Cancel</button>
    <button (click)="save()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="processor-device-save-button">Save</button>
  </div>
</div>
